import Box from "@/components/Box";
import ButtonV2 from "@/v2/Buttons";

export const DIAGRAM_ZOOM_MIN = 0.5;
export const DIAGRAM_ZOOM_MAX = 3;
export const DIAGRAM_ZOOM_STEP = 0.25;

const clampZoom = scale => Math.min(DIAGRAM_ZOOM_MAX, Math.max(DIAGRAM_ZOOM_MIN, scale));

export const zoomIn = scale => clampZoom(scale + DIAGRAM_ZOOM_STEP);
export const zoomOut = scale => clampZoom(scale - DIAGRAM_ZOOM_STEP);

const DiagramZoomControls = ({ scale, onZoomIn, onZoomOut }) => (
  <Box display="flex" gap={8} flexShrink={0}>
    <ButtonV2
      color="dark"
      size="xs"
      type="button"
      disabled={scale <= DIAGRAM_ZOOM_MIN}
      onClick={onZoomOut}
    >
      Zoom out
    </ButtonV2>
    <ButtonV2
      color="dark"
      size="xs"
      type="button"
      disabled={scale >= DIAGRAM_ZOOM_MAX}
      onClick={onZoomIn}
    >
      Zoom in
    </ButtonV2>
  </Box>
);

export default DiagramZoomControls;
